module.exports = __webpack_public_path__ + "static/img/form-logo.7282ce89.png";